import type { FunctionalRoleOption } from "@atoms/atom-types";
import {
  DESIGNER_ENGINEER_PERMISSION,
  ORDER_MANAGER_PERMISSION,
  PRICE_CALCULATOR_PERMISSION,
  SUNLAB_IMPORT_TEMPLATES_PERMISSION,
  USER_MANAGER_PERMISSION,
} from "./roleConstants";

/**
 * Functional role options for user administration UI.
 * Labels and descriptions are app-specific; role keys must match `provisionPermissionsByRoles`.
 */
export const functionalRoleOptions: FunctionalRoleOption[] = [
  {
    value: ORDER_MANAGER_PERMISSION,
    label: "Bestellungsadmin",
    description: "Bestellungen importieren und Import-Protokolle einsehen",
  },
  {
    value: PRICE_CALCULATOR_PERMISSION,
    label: "Preisberechnung",
    description: "Preisdaten und Preisparameter verwalten",
  },
  {
    value: DESIGNER_ENGINEER_PERMISSION,
    label: "Designer / Engineer",
    description:
      "Positionen, Bestellungen, Vorlagen, Optionsbibliothek und Modelle bearbeiten",
  },
  {
    value: SUNLAB_IMPORT_TEMPLATES_PERMISSION,
    label: "Sunlab Import Vorlagen",
    description: "Vorlagen verwalten und getaggte Sunlab-Vorlagen bearbeiten",
  },
  {
    value: USER_MANAGER_PERMISSION,
    label: "Nutzerverwalter",
    description: "Benutzer einladen, bearbeiten und Passwort-Reset senden",
  },
];
